import React from 'react';
import { BrowserRouter, RouterProvider } from 'react-router-dom';
import Routes, { routerConfig } from './routes';
import './App.scss';
import { HttpError, HttpPrimaryError } from './utils/datatype';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount: number, error: HttpError<HttpPrimaryError>) => {
        if(error.isRetry){
          return failureCount < 3;
        }
        return false;
      }
    }
  }
});

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        {/* <BrowserRouter>
          <Routes />
        </BrowserRouter> */}
        <RouterProvider router={routerConfig}></RouterProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
